import React, { Component } from 'react';
import {List, Avatar, Button, Form, Select, message, Modal, Input} from 'antd';
import {getWorkflow,getTask,getTaskwithoutworkflow,chasingList,insertlog,linkeddois,UpdateDoi} from '../../stores/APIEndpoints';
import {booleanAsString, toUrlParams} from "../../stores/Util";
import looseLeafStore from "../../stores/LooseLeafStore";
import DashboardStore from '../../stores/DashboardStore';
import {appStore} from '../../stores/AppStore';
import {inject, observer} from 'mobx-react';
import '../../../src/index.css';
import moment from 'moment';
let slectmulDates = [];
@inject('dataStore')
@observer
class LooseLeafChasingUnits extends Component {
  
    constructor(props) {
        super(props);
        this.apiProxy = appStore.apiProxy;
       this.state = {
          initLoading: false,
          loading: false,
          chasingId:'',
          data: [],
          list: [],
          dropDownList:'',
          deleteOrAdd :"false",
          visible:false,
          deleteComment:'',
          commentBox:false,
          currentItem:'',
        };
    }
    get store() {
        return DashboardStore;
      
    }
    async componentDidMount() {

        this.getChasingList();
        this.getSelectedChasingList();
      }  
    deleteDoi=async(item)=>{
      this.setState({deleteOrAdd:"false"});
      this.setState({currentItem:item});
      this.showModal();
      // var ary = this.state.data;
      // ary.splice(item, 1);
      // this.addOrRemove(ary, "delete");
      // this.setState({data:ary});
    }
    showModal = () => {
      this.setState({
        visible: true,
      });
    };
    getChasingList = async() =>
    {
          const currentData = this.store.currentData;
          const params = {
              projectId:currentData.projectId
          };
          const url = chasingList + '?' + toUrlParams(params);
          const response = await this.apiProxy.getAsync(url);
          let dt = await response.json();
          if(dt.length == 0)
          {
            this.setState({data:[]});
            return false;
          }
          if(dt[0].linked_dois == null)
          {
           this.setState({data:[]});
          }
          else
          {
            this.setState({chasingId:dt[0].id});
            dt = dt[0].linked_dois.split(',');
            this.setState({data:dt});
          }
    }
    getSelectedChasingList = async() => {
      const currentData = this.store.currentData;
          const params = {
            country:currentData.publication,
            abbreviation:currentData.abbreviation
          };
          const url = linkeddois + '?' + toUrlParams(params);
          const response = await this.apiProxy.getAsync(url);
          let dt = await response.json();
      
          if(dt.length == 0)
          {
            this.setState({dropDownList:[]});
            return false;
          }
          if(dt[0].linked_dois == null)
          {
           this.setState({dropDownList:[]});
          }
          else
          {
           // dt = dt[0].linked_dois.split(',');
            this.setState({dropDownList:dt});
          }
    }
    addOrRemove = async(dt, addRemove) =>
    {
      const currentData = this.store.currentData;
        const params2 = {
          id:this.state.chasingId,
          projectId:currentData.projectId,
          linkedDois:dt.toString(),
        };
        const response = await this.apiProxy.asyncPost(UpdateDoi, params2);
        const data = await response.json();
        if(response.status == 200)
        {
          this.insertlog(addRemove);
          this.setState({
            visible: false
          });
          this.setState({deleteComment:""});
        }
    }
    insertlog = async(action)=>
    {
      const currentData = this.store.currentData;
           const params2 = {
            refId:currentData.id,
            refType:"LooseLeafSeed",
            userId:appStore.credentials.userId,
            action:action,
            createdAt:new Date(),
            updatedAt:new Date()
        };
        const url1 = await this.apiProxy.asyncPost(insertlog, params2);
        const data1 = await url1.json();
    }
     
    chasingList=()=>{
      return(
      <List
      header={<div>Removing document from chasing unit</div>}
      bordered
      dataSource={this.state.data}
      renderItem={(item,me) => (
        <List.Item actions={[<a key="list-loadmore-edit" value={item} onClick={()=>this.deleteDoi(me)}>Delete</a>]}>
        <List.Item.Meta
          avatar={<Avatar src="" />}
          title={<a href="https://ant.design">{item.title}</a>}
          description={item}
        />
        </List.Item>
      )}
      />
      )
    }
    onChange=()=>{

    }
getListValue = ()=>{
  console.log(this.state.dropDownList);
  let items = this.state.dropDownList.map((item) =>
      <option value={item.linked_dois}>{item.linked_dois}</option>
  );
  return items;
}
handleSubmit = e => {
  e.preventDefault();
  this.props.form.validateFields((err, values) => {
    if (!err) {

      this.setState({deleteOrAdd:"true"});
      this.setState({currentItem:values.chasingId});
      this.showModal();

       
    }
  });
};
userComents =(value) => {
  this.setState({deleteComment:value.target.value});
 }
 handleCancel = e => {
  console.log(e);
  this.setState({
    visible: false
  });
  this.setState({
    deleteComment: ''
  });
  this.setState({commentBox:false});
  // const val = this.state.currentHoldStatus;
  // this.setState({hold:val});
};
 handleOk = e => {
  if(this.state.deleteOrAdd == "true")
  {
    if(this.state.deleteComment == '' || this.state.deleteComment != 'Add Chasing')
    {
      this.setState({commentBox:true});
      return false;
    }
    else
    {
      const {data, currentItem} = this.state;
      const arrayDt = data;
      if(arrayDt.indexOf(currentItem) == -1)
      {
        arrayDt.push(currentItem);
        this.addOrRemove(arrayDt, "add");
        this.setState({data:arrayDt});
      }
      else
      {
        message.error('Document is already available in the chasing unit..');
      }
      this.setState({commentBox:false});
    }
  }
  else
  {
    if(this.state.deleteComment=='Delete Chasing')
    {
      const {data, currentItem} = this.state;
      var ary = data;
      ary.splice(currentItem, 1);
      this.addOrRemove(ary, "delete");
      this.setState({data:ary});
      this.setState({commentBox:false});
    }
    else
    {
      this.setState({commentBox:true});
      return false;
    }
  }
};
getUpdateWip=(operation)=>{
  alert(operation);
}
  render() {
     const { getFieldDecorator } = this.props.form;
     const data = this.store.currentData;
     const title = data.id === undefined ? "New Title" : data.abbreviation + " - " + data.publication;
     const { dropDownList, deleteOrAdd } = this.state;
  
    return (
        <div>
        {this.chasingList()}
        <br/>
        <Form name="normal_login"  className="login-form" onSubmit={this.handleSubmit}>
          <Form.Item label="Adding document to chasing unit"  name="chasing unit">
              {getFieldDecorator('chasingId', {
                  rules: [{required: true, message: 'Please input your Linked dois.'}]
                })(
                <Select
                    showSearch
                    placeholder="Adding document to chasing unit"
                    optionFilterProp="children"
                    onChange={this.onChange}
                    filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                 >
                   { dropDownList != "" ? dropDownList.map(value =>  <Option value={value.linked_dois}>{value.linked_dois}</Option>) : <Option value=''>''</Option>}
             {/* {this.getListValue()}       */}
                {/* <Option value="MIP-INIA-DOC(202020103)">QA - Indonesia Drafting Agreements (20200805)</Option>
                <Option value="MIP-INIA-DOC(202020103)">QA - Indonesia Privacy and Confidentiality (20200805)</Option>
                <Option value="MIP-INIA-DOC(202020103)">QA - Indonesia State Immunity (20200805)</Option> */}
              </Select>,
              )}
          </Form.Item> 
          <Form.Item>
              <Button style={{"float":"right","margin-top":"10px"}} htmlType="submit" type="primary" className="login-form-button">Add</Button>
          </Form.Item>
        </Form>
        <Modal
        title={title}
        visible={this.state.visible}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
      >
        {deleteOrAdd == "true" ?
        <div>
            <div>Please type "<b>Add Chasing</b>" to add chasing units.</div>
            <br/>
            <Input value={this.state.deleteComment} onChange={this.userComents} placeholder={"Add Chasing"} />
            {this.state.commentBox? <div style={{"color":"red"}}><sup>*</sup>Text not matching...</div>:''}
        </div>:
        <div>
          <div>Please type "<b>Delete Chasing</b>" to delete chasing units.</div>
          <br/>
          <Input value={this.state.deleteComment} onChange={this.userComents} placeholder={"Delete Chasing"} />
          {this.state.commentBox? <div style={{"color":"red"}}><sup>*</sup>Text not matching...</div>:''}
      </div>}
    </Modal>
      </div>
    );
  }
}

export default Form.create({ name: 'normal_login' })(LooseLeafChasingUnits);

// export default WrappedNormalLoginForm;

